/**
 * Wraps an RTK Query baseQuery to automatically inject the current language
 * into every request body (POST/PUT/PATCH) or query params (GET),
 * sourced from localStorage (set by i18n.js).
 */
export const withLang = (baseQuery) => async (args, api, extraOptions) => {
  const lang = localStorage.getItem("scoreholio_lang") || "en";
  let modifiedArgs = args;
  if (args && typeof args !== "string") {
    if (args.method === "GET" || (!args.method && !args.body)) {
      // GET request — inject via query params
      modifiedArgs = {
        ...args,
        params: { ...args.params, lang },
      };
    } else {
      // POST/PUT/PATCH — inject via body
      modifiedArgs = {
        ...args,
        body: args.body ? { ...args.body, lang } : { lang },
      };
    }
  }
  console.log("[withLang] args:", modifiedArgs);
  return baseQuery(modifiedArgs, api, extraOptions);
};
